export default "/fonts/roboto-medium-webfont.woff2?8b6406b1b4511c19ab08df53e40fdd57";